import { userLoginToken } from "utils/general-utils";

/**
 * Downloads a CSV file containing removal data for a specific interest list.
 *
 * @param interestListId - The ID of the interest list to download removals for
 * @returns A promise that resolves when the download is complete
 * @throws {Error} When the API request fails or returns a non-200 status
 */

export const downloadRemovalsCsv = async (interestListId: string): Promise<void> => {
  const token = userLoginToken();
  const fileName = `removals-${Date.now()}.csv`;

  const res = await fetch("/api/removals/dl/spreadsheet", {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${token}`,
      filename: fileName,
    },
    // eslint-disable-next-line camelcase
    body: JSON.stringify({ interest_list_id: interestListId }),
  });

  if (res.status !== 200) throw new Error("Error downloading CSV");

  const csvString = await res.text();
  const blob = new Blob([csvString], { type: "text/csv" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("style", "visibility:hidden");
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
